import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    quote: 'Llevaba tres años con dolor en las rodillas cada mañana. Me decían que era normal para mi edad. Después de dos semanas con el protocolo articular de Sinergia Ancestral, la rigidez bajó de forma notable. No me lo podía creer.',
    name: 'Elena R.',
    age: 61,
    location: 'Ciudad de México'
  }, {
    quote: 'El módulo del sueño me cambió la vida. Llevaba meses despertándome a las 3 de la madrugada. La Leche de Luna y el ritual del apagado parasimpático transformaron mis noches por completo. Ahora duermo de un tirón y me levanto con energía real.',
    name: 'Carmen V.',
    age: 58,
    location: 'Buenos Aires'
  }, {
    quote: 'Soy muy escéptica. Pero cuando vi las referencias a estudios científicos y la explicación sobre biodisponibilidad, entendí que no era folklore. Era ciencia real aplicada. El módulo digestivo cambió mi bienestar en menos de una semana.',
    name: 'Patricia M.',
    age: 55,
    location: 'Madrid'
  }, {
    quote: 'La hinchazón después de comer era tan constante que ya la había normalizado. La Mezcla Digestiva lo cambió en días. Simple, económico y completamente efectivo. Por $6 no hay nada que perder y todo que ganar.',
    name: 'Roberto A.',
    age: 63,
    location: 'Bogotá'
  }, {
    quote: 'Compré el libro para mi mamá de 67 años y quedó maravillada. Dice que es el primer libro de salud natural que explica el por qué de cada cosa en lugar de solo decirte qué tomar. Lo recomiendo sin dudarlo.',
    name: 'Daniela F.',
    age: 41,
    location: 'Santiago de Chile'
  }];
  return <section ref={ref} className="py-10 md:py-16 px-4 bg-white" data-id="element-313">
      <div className="max-w-6xl mx-auto" data-id="element-314">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-315">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-warm-brown mb-8 md:mb-12 text-center px-2" data-id="element-316">
            Lo Que Dicen Quienes Ya Lo Tienen
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-317">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 30
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-cream rounded-lg p-5 md:p-6 border-2 border-sage-light shadow-lg" data-id="element-318">
                <div className="flex gap-1 mb-3 md:mb-4" aria-label="5 estrellas" data-id="element-319">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-terracotta text-terracotta" aria-hidden="true" data-id="element-320" />)}
                </div>
                <blockquote className="text-gray-700 mb-3 md:mb-4 italic text-sm md:text-base" data-id="element-321">
                  "{testimonial.quote}"
                </blockquote>
                <div className="text-xs md:text-sm font-semibold text-gray-900" data-id="element-322">
                  {testimonial.name}, {testimonial.age} años
                </div>
                <div className="text-xs md:text-sm text-sage-dark" data-id="element-323">
                  {testimonial.location}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}